import { Injectable, UseFilters } from '@nestjs/common';
import { getManager, Repository } from 'typeorm';
import { DesignationAction } from './designation-action.entity';
import { DesignationActionDTO } from './dto/designation-action.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { DesignationActionAdapter } from './dto/designation-action.adapter';
import { DesignationActionResponseModel, AllDesignationActionResponseModel } from '@gtpl/shared-models/hrms';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { DesignationActionRequest } from './dto/designation-action.request';
import { CertificatesResponseModel, CommonResponse, EmployeeDepartmentRequest, EmployeeDesignationRequest } from '@gtpl/shared-models/masters';
import { DepartmentService, EmployeeService } from '@gtpl/shared-services/masters';
import appSettings from 'apps/services/config';
// import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { BroadCastMessageRequest } from '@gtpl/shared-models/whatsapp-broad-cast';
import whatsApp from 'apps/services/whatsapp';
@Injectable()
export class DesignationActionService {
    constructor(
        @InjectRepository(DesignationAction)
        private repo: Repository<DesignationAction>,
        private adapter: DesignationActionAdapter,
        private employeeService: EmployeeService,
        private deptService: DepartmentService,
        private wtsAppBroadCatService: WhatsappBroadCastService,
    ) { }

    async getDesignationActionDetailsWithoutRelations(designationActionId: number): Promise<DesignationAction> {
        const designationActionResponse = await this.repo.findOne({
            where: { designationActionId: designationActionId },
        });
        if (designationActionResponse) {
            return designationActionResponse;
        } else {
            return null;
        }
    }

    async createDesignationAction(dto: DesignationActionDTO, isUpdate: boolean): Promise<DesignationActionResponseModel> {
        try {
            if (!isUpdate) {
                const entity = await this.getDesignationActionDetailsWithoutRelations(dto.designationActionId);
                if (entity) {
                    throw new ErrorResponse(11104, 'DEsignation Action already exists');
                }
            } else {
                const entity = await this.getDesignationActionDetailsWithoutRelations(dto.designationActionId);
                if (entity) {
                    if (entity.designationActionId != dto.designationActionId) {
                        throw new ErrorResponse(11104, 'DEsignation Action already exists')
                    }
                }
            }
            const convertedEntity: DesignationAction = this.adapter.convertDtoToEntity(dto, isUpdate);
            const savedEntity: DesignationAction = await this.repo.save(convertedEntity);
            const desReq = new EmployeeDesignationRequest(dto.employeeId, dto.toDesignation);
            const deptReq = new EmployeeDepartmentRequest(dto.employeeId, dto.toDepartment);
            console.log(desReq, 'req')
            console.log(deptReq, 'req for department')
            const updateEmployeeData = await this.employeeService.updateDesignationForDesignationAction(desReq)
            const updateEmployeeDeptData = await this.employeeService.updateDepartmentForDesignationAction(deptReq)
            const savedDto: DesignationActionDTO = this.adapter.convertEntityToDto(convertedEntity);
            if (savedDto && updateEmployeeData && updateEmployeeDeptData) {
                const mes = " \n " + 'Employee Code:' + dto.employeeCode + " \n " + 'Employee Name:' + dto.employeeName + " \n " + 'From department:' + dto.department + "\n" + 'To Department:' + dto.toDepartment + "\n" + 'From Designation:' + dto.fromDesignation + "\n " + 'To Designation:' + dto.toDesignation + "\n " + 'ApprovedBy:' + dto.approvedBy + "\n "
                const msgReq = new BroadCastMessageRequest(31, mes, [whatsApp.UsageReport])
                const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(msgReq);
                if (messageStatus) {
                    const response = new DesignationActionResponseModel(true, 1, isUpdate ? 'Designation Action Updated Successfully' : 'DEsignation Action Created Successfully', savedDto);
                    return response;
                } else {
                    throw new ErrorResponse(11106, 'Designation Action saved but issue while transforming it into DTO');
                }

            }
        }
        catch (error) {
            throw error;
        }
    }


    // async getAllDesignationActions(): Promise<AllDesignationActionResponseModel> {
    //     try {
    //         const desDto: DesignationActionDTO[] = [];
    //         const desEntity: DesignationAction[] = await this.repo.find({ order: { designationActionId: 'DESC' } });
    //         const deptIds: number[] = Array.from(new Set(desEntity.map(res => Number(res.department))));
    //         const AllDepartmentsResponseModel = await this.deptService.getDepartmentNameByDeptIds(deptIds);
    //         console.log(AllDepartmentsResponseModel)
    //         if (desEntity.length) {
    //             const deptMap = new Map();
    //             AllDepartmentsResponseModel?.data?.forEach(res => {
    //                 deptMap.set(res.deptId, res.deptName);
    //             });
    //             desEntity.forEach(entity => {
    //                 const convertedDto: DesignationAction = this.adapter.convertEntityToDto(entity);
    //                 convertedDto.department = deptMap.get(Number(entity.department)) ? deptMap.get(Number(entity.department)) : entity.department;
    //                 desDto.push(convertedDto);
    //             });
    //             const response = new AllDesignationActionResponseModel(true, 1, 'Designation Action Retrieved Successfully', desDto);
    //             return response;
    //         } else {
    //             throw new ErrorResponse(99998, 'Data Not Found');
    //         }
    //     } catch (err) {
    //         throw err;
    //     }
    // }
    async getAllDesignationActions(): Promise<CommonResponse> {
        try{
            const manager = getManager();
        const query = `SELECT da.designation_action_id AS designationActionId ,da.created_at AS createdDate, da.designation_date AS designationDate, da.employee_code AS employeeCode,
        da.employee_name AS employeeName, da.department, da.to_department AS toDepartmentId , dep.dept_name AS toDepartment, da.from_designation AS fromDesignation,
        da.to_designation AS toDesignationId,
        d.designation AS toDesignation, da.approved_by AS approvedBy FROM `+ appSettings.hrms_db +`.designation_action da
        LEFT JOIN `+ appSettings.hrms_db +`.designation d ON d.designation_id = da.to_designation
        LEFT JOIN `+ appSettings.masters_db +`.departments dep ON dep.dept_id = da.to_department;`
        const data = await manager.query(query)
        if (data.length > 0) {
            const response = new CommonResponse(true, 11208, "Report retrieved successfully", data);
            return response;
        } else {
            throw new CommonResponse(false, 99998, 'No Record Found');
        }
        }catch(err){
            throw err
        }
        
    }

    async getAllActiveDesignationActions(): Promise<AllDesignationActionResponseModel> {
        try {
            const desDto: DesignationActionDTO[] = [];
            const desEntity: DesignationAction[] = await this.repo.find({ order: { designationActionId: 'ASC' }, where: { isActive: true }, });
            if (desEntity) {
                desEntity.forEach(Entity => {
                    const convertedEntity: DesignationActionDTO = this.adapter.convertEntityToDto(Entity);
                    desDto.push(convertedEntity);
                });
                const response = new AllDesignationActionResponseModel(true, 11108, 'Active Designation Action Retrieved Successfully');
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getDesignationById(designationActionId: number): Promise<DesignationAction> {
        const response = await this.repo.findOne({
            where: { designationActionId: designationActionId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateDesignation(catReq: DesignationActionRequest): Promise<DesignationActionResponseModel> {
        try {
            const catExists = await this.getDesignationById(catReq.designationActionId);
            if (catExists) {
                if (catReq.versionFlag != catExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the curren DEsignation Action information. Refresh and try again');
                } else {
                    const catStatus = await this.repo.update(
                        { designationActionId: catReq.designationActionId },
                        { isActive: catReq.isActive, updatedUser: catReq.updatedUser }
                    );
                    if (catExists.isActive) {
                        if (catStatus.affected) {
                            const catResponse: DesignationActionResponseModel = new DesignationActionResponseModel(true, 10115, 'DEsignation Action is de-activated successfully');
                            return catResponse;
                        } else {
                            throw new ErrorResponse(10111, ' DEsignation Action is already de-activated');
                        }
                    } else {
                        if (catStatus.affected) {
                            const catResponse: DesignationActionResponseModel = new DesignationActionResponseModel(true, 10114, 'DEsignation Action is activated successfully');
                            return catResponse;
                        } else {
                            throw new ErrorResponse(10112, 'DEsignation Action is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
}
